dayjs.extend(dayjs_plugin_utc);
dayjs.extend(dayjs_plugin_timezone);

const NYhour = parseInt(dayjs.tz(new Date(), "America/New_York").format('H'));
const NYminutes = parseInt(dayjs.tz(new Date(), "America/New_York").format('m'));
if (NYhour > 8 && NYhour < 14) {
  const hoursUntilCutOff = 13 - NYhour;
  const minutesFromTheHour = 60 - NYminutes;
  const desktopElement = document.getElementById('shipping-cutoff');
  if (desktopElement) {
    const desktopHours = desktopElement.getElementsByClassName("hours")[0];
    const desktopHrString = desktopElement.getElementsByClassName("hr-string")[0];
    const desktopMinutes = desktopElement.getElementsByClassName("minutes")[0];
    if (hoursUntilCutOff > 0)  {
        desktopHours.innerHTML = hoursUntilCutOff;
        desktopHours.style.display = 'inline-block';
        desktopHrString.style.display = 'inline-block';
    } else {
      desktopHours.style.display = 'none';
      desktopHrString.style.display = 'none';
    }
    desktopMinutes.innerHTML = minutesFromTheHour;
    desktopElement.style.display = "block";
  }
}